'use client'
import React from 'react'

import NotFountPage from 'Components/Pages/_Legacy/NotFount'

export default function NotFound() {
  return <NotFountPage />
}
